'use client';

import {
  DialogHeader,
  DialogTitle,
  DialogClose,
  DrawerHeader,
  DrawerTitle,
  DrawerClose,
} from '@shared/ui';
import { X } from 'react-feather';
import { useOtpContext } from '../model';
import { useMobile } from '@shared/hooks';

interface OtpHeaderProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

export const OtpHeader: React.FC<OtpHeaderProps> = ({ children, icon, className }) => {
  const { setOpen } = useOtpContext();
  const isMobile = useMobile();

  const handleClose = () => setOpen(false);

  const Header = isMobile ? DrawerHeader : DialogHeader;
  const Title = isMobile ? DrawerTitle : DialogTitle;
  const Close = isMobile ? DrawerClose : DialogClose;

  return (
    <Header>
      <div className='flex items-center justify-between w-full px-5 md:px-0'>
        <div className='flex items-center justify-center gap-2'>
          {icon && <div className=''>{icon}</div>}
          <Title className='text-right text-text body-13-bold leading-normal'>{children}</Title>
        </div>
        <Close className='text-text focus-visible:outline-none p-1'>
          <X className='text-text' size={24} strokeWidth={1} />
        </Close>
      </div>
      <div className='flex hover:bg-hover rounded-md cursor-pointer' onClick={handleClose}></div>
    </Header>
  );
};
